
import AppEditProduct from "@/components/products/ProductEdit.vue";
import { Product } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { PriceListProductService } from "@/services/price-list-product-service";
import { ProductService } from "@/services/product-service";
import { ToolbarService } from "@/services/toolbar-service";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		let warningText = () => {
			return this.$ct("cancel-confirm").toString();
		};
		return {
			id: 0,
			product: new Product(),
			pendingChangesNotifier: new PendingChangesNotifier(this, "product", {warningText}),
		};
	},
	props: {
		productId: Number
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		},
		isInfo():boolean {
			return this.$route.fullPath.includes("/info/");
		},
	},
	methods: {
		async saved(product: Product, returnToView:boolean) {
			this.pendingChangesNotifier.changesPending = false;
			this.product = await ProductService.getProduct(product.ID);
			this.pendingChangesNotifier.changesPending = false;
			this.$emit("saved",product);
			if (this.id == 0) {
				this.$emit("created-new-product");
			}
			if (returnToView){
				this.$router.push("/products");
			}
		},
		async onCancel() {
			this.$router.push("/products");
		},
		clearChanges() {
			this.pendingChangesNotifier.changesPending = false;
		},
		onDeleted() {
			this.$router.push(`/products`);
		},
		onInput(event: Product) {
			this.product = event;
		},
		async saveProduct(){
			let success = await (this.$refs.AppEditProduct as any).save();
			if (!success){
				return false;
			}
			if (this.product.ID != 0) {
				let product = this.product as Product;
				this.product = new Product();
				ProductService.lastOpenedItem.setLastOpenedItem(product.getLastOpenedJSON());
				if (this.id == 0) {
					this.$emit("created-new-product");
				}
			}
			return true;
		},
	},
	async mounted() {
		this.id = parseInt(this.$route.params.id);
		if (Number.isNaN(this.id)){
			this.id = 0;
		}
		if (this.productId) {
			this.id = this.productId;
		}
		if (this.id) {
			ToolbarService.title = this.$ct("title-edit");
			this.product = await ProductService.getProduct(this.id);
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		} else {
			ToolbarService.title = this.$ct("title-new");
			if (typeof(this.$route.query.priceListJson) == "string"){
				this.product = await PriceListProductService.toProduct(JSON.parse(decodeURIComponent(this.$route.query.priceListJson || "{}")));
			}
			if (this.product.ExtraFields){
				DossierConfigService.getExtraFieldNamesConfigs().ProductNames.setDefaultValues(this.product.ExtraFields);
			}
		}
	},
	components: {
		AppEditProduct
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
	async beforeRouteLeave(to, from, next) {
		if(this.isInfo){
			next();
			return;
		}
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			let success = await this.saveProduct();
			if (!success) return;
		}
		this.product.ID = 0;
		this.product.Sku = null;
		ProductService.lastOpenedItem.setLastOpenedItem(this.product.getLastOpenedJSON());
		next();
	}
});
